var map = {
	"./arrow-left.svg": 1683,
	"./arrow-right.svg": 2153,
	"./ausleihen.svg": 2093,
	"./blood-analysis.svg": 9497,
	"./borrow.svg": 2083,
	"./brief.svg": 8774,
	"./burger-menu.svg": 8993,
	"./calendar.svg": 3927,
	"./care.svg": 1528,
	"./checking.svg": 572,
	"./chevron.svg": 5080,
	"./clock.svg": 7017,
	"./close.svg": 6283,
	"./consultation.svg": 3932,
	"./cosmetic.svg": 2830,
	"./environmental-analysis.svg": 7485,
	"./error.svg": 8447,
	"./facebook.svg": 6054,
	"./focal-points.svg": 319,
	"./ic_adresse.svg": 1729,
	"./ic_aktuelles.svg": 7721,
	"./ic_arrow down.svg": 9459,
	"./ic_arrow up.svg": 5247,
	"./ic_facebook.svg": 3538,
	"./ic_instagram.svg": 6439,
	"./ic_kontakt.svg": 5061,
	"./ic_menue.svg": 4806,
	"./ic_oeffnungszeiten.svg": 5741,
	"./ic_reservierung.svg": 3686,
	"./ic_twitter.svg": 3182,
	"./ic_youtube.svg": 3592,
	"./instagram.svg": 2699,
	"./language.svg": 9435,
	"./location.svg": 7031,
	"./mail-alt.svg": 8251,
	"./mail.svg": 7036,
	"./more.svg": 698,
	"./naturopathy.svg": 1654,
	"./phone.svg": 49,
	"./production.svg": 2818,
	"./services.svg": 8523,
	"./shop.svg": 7027,
	"./telefon.svg": 4251,
	"./test.svg": 18,
	"./twitter.svg": 1297,
	"./youtube.svg": 7494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8194;